<template>
  <div class="first-section-container">

    <!-- 3D SECTION -->
    <v-sheet class="first-3d pa-2">
      <kuhul-3D-component 
        :id="'1'" 
        :link3d="'/models/canette-1-perfect.fbx'" 
      />
    </v-sheet>

    <!-- CARDS SECTION -->
    <v-sheet class="cards-container pa-2">

      <div class="cards-title">
        <h1>WHAT'S NEW</h1>
      </div>

      <welcome-text-container
        @nextStep="componentStep = 2"
        v-if="componentStep === 1"
      />

      <div 
        class="cards-wrapper" 
        v-show="componentStep === 2"
      >
        <div class="cards-track">
          <kuhul-card-product
            v-for="(card, index) in cards"
            :key="index"
            :project="card"
            class="stack-card"
            @buyNow="$emit('buyNow')"
          />
        </div>
      </div>

    </v-sheet>

  </div>
</template>

<script>
import WelcomeTextContainer from "./WelcomeTextContainer";
import Kuhul3DComponent from "./Kuhul3DComponent.vue";
import KuhulCardProduct from "./KuhulCardProduct.vue";

export default {
  name: "FirstSection",
  components: {
    WelcomeTextContainer,
    KuhulCardProduct,
    Kuhul3DComponent,
  },

  data: () => ({
    componentStep: 2,
    cards: [
      {
        title: "Kuhul Falak",
        description:
          "Falak (“cosmos” in Arabic) Brewed with Citra, Mosaic, and Motueka, Falak is a hazy NEIPA with a soft, juicy body.",
        link:
          "https://www.bieresgourmet.be/fr/hazy-new-england-ipa/6446-kuhul-falak.html",
        bgColor: `#89CBAD`,
        backgroundImageUrl: `/models/IMG_0321.JPG`,
        priceItems: [
          { number: 12, price: 45 },
          { number: 24, price: 84 },
        ],
      },
    ],
  }),
};
</script>

<style scoped>

/* ===== LAYOUT ===== */
.first-section-container {
  display: flex;
  gap: 20px;
  width: 100%;
}

/* 🔥 CRITICAL FIX (flex bug) */
.first-section-container > * {
  min-width: 0;
}

/* ===== 3D ===== */

.first-3d {
  flex: 0 0 40%;
  height:800px;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  position: relative;
  overflow: hidden;
}


/* ===== CARDS ===== */
.cards-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: black !important;
}

.cards-title {
  font-family: 'Poppins', sans-serif !important;
  font-weight: bold;
  font-size: 40px;
  text-align: center;
  margin-bottom: 20px;
}

/* ===== CARDS LIST ===== */
.cards-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.cards-track {
  display: flex;
  align-items: flex-start;
}

.stack-card {
  min-width: 300px;
  flex-shrink: 0;
  margin-left: -200px;
  transition: transform 0.4s ease;
}

.stack-card:first-child {
  margin-left: 0;
}

/* ===== TABLET ===== */
@media (max-width: 1264px) {
  .first-3d {
     width: 50%;

    height: 600px;
  }
}

/* ===== MOBILE ===== */
@media (max-width: 960px) {
  .first-section-container {
    flex-direction: column;
  }

  .first-3d {
    background: black;
    width: 100vw !important;
    height: 70vh !important;
    flex: none !important;
  }

  .cards-container {
     flex: 0 0 60%;
  }

  .cards-title {
    font-size: 28px;
  }

  .cards-track {
    flex-direction: column;
    align-items: center;
  }

  .stack-card {
    margin-left: 0;
    margin-bottom: 20px;
    width: 90%;
  }
}

</style>